import api from "../../Environment";

/**
 * Unified Content Item API client.
 */
export function fetchContentTypes() {
  return api.postMethod("content/types", {}).then((r) => r.data);
}

export function fetchContentList(params) {
  return api.postMethod("content", params || {}).then((r) => r.data);
}

export function fetchContentShow(params) {
  // Never send `id` for content lookup — Environment.postMethod reserves `id` for auth userId.
  const safe = Object.assign({}, params || {});
  if (safe.id != null && (safe.slug || safe.unique_id || safe.content_item_id)) {
    delete safe.id;
  }
  return api
    .postMethod("content/show", safe)
    .then((r) => r.data)
    .catch((err) => {
      const status = err && err.response && err.response.status;
      const body = err && err.response && err.response.data;
      // Scheduler channels often have no ContentItem — soft miss, not a page failure.
      if (status === 404 || (body && body.success === false)) {
        return {
          success: false,
          error: "not_found",
          error_code: status || 404,
          error_messages:
            (body && body.error_messages) || "Content item not found",
        };
      }
      throw err;
    });
}

export function fetchContentSearch(params) {
  return api.postMethod("content/search", params || {}).then((r) => r.data);
}

export function fetchContentRecommendations(params) {
  return api
    .postMethod("content/recommendations", params || {})
    .then((r) => r.data);
}

export function fetchContentHomeRows(params) {
  return api.postMethod("content/home_rows", params || {}).then((r) => r.data);
}

export function fetchSubcategoryContent(params) {
  return api
    .postMethod("content/subcategory", params || {})
    .then((r) => r.data);
}

export function contentDetailPath(item) {
  if (!item) return "/home";
  if (item.detail_route) return item.detail_route;
  if (item.playback && item.playback.tune_url) return item.playback.tune_url;
  const type = String(item.content_type || "video").toLowerCase();
  if (type === "channel") {
    return "/channels/" + (item.slug || item.unique_id || item.channel_id);
  }
  if (type === "sub_category") {
    const slug = item.slug && String(item.slug).trim();
    return "/sub-category/" + (slug || item.sub_category_id || item.id || "");
  }
  if (type === "video") {
    return "/video/" + (item.admin_video_id || item.contentable_id || item.id);
  }
  return "/home";
}
